
webpack.register(
    'modules/history-experience-collections-landing/history-experience-collections-landing',
    function() {
        return import('modules/history-experience-collections-landing/history-experience-collections-landing');
    },
    true
);